export default __webpack_public_path__ + "static/media/epmG.b2d03df1.png";